// Prescriptions can be JPG/PNG images or PDF/DOC/DOCX documents. Only the
// image types can actually render inside an <img> tag — for the rest,
// callers should show a labeled document tile instead of letting the
// image silently fail (or fall back to a generic broken-image icon that
// looks the same for every non-image file, making them impossible to
// tell apart without opening each one).
export const getFileKind = (url) => {
  const ext = (url || "")
    .split("?")[0]
    .split(".")
    .pop()
    ?.toLowerCase();
  if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) {
    return { isImage: true, label: ext.toUpperCase() };
  }
  if (ext === "pdf" || ext === "doc" || ext === "docx") {
    return { isImage: false, label: ext.toUpperCase() };
  }
  return { isImage: false, label: "FILE" };
};
